/**
 * Styled Components - Created by david on 08/06/18.
 */
import Icon from 'antd/lib/icon'
import styled from 'styled-components'
import { BLUE, BLUE_SKY, GRAY_DARK, WHITE } from '../../../theme/colors'

export const Container = styled.div`
  overflow-y: scroll;
  height: calc(100vh - 164px);
`

export const ProductContainer = styled.div`
  padding: 0 18px;
  padding-top: 14px;
  font-family: Avenir;
`

export const TitleSubtitleContainer = styled.div``

export const Title = styled.div`
  color: ${GRAY_DARK};
  font-size: 20px;
  font-weight: bold;
  line-height: 33px;
  display: flex;
  align-items: center;
  @media (min-width: 320px) and (max-width: 480px) {
    font-size: 18px;
  }
`

export const MenIcon = styled(Icon)`
  margin-left: 8px;
  font-size: 16px;
  color: ${BLUE_SKY};
`

export const WomenIcon = styled(Icon)`
  margin-left: 8px;
  font-size: 16px;
  color: deeppink;
`

export const YouthLabel = styled.div`
  font-size: 10px;
  color: #549c8c;
  margin-left: 5px;
  display: inline-block;
  vertical-align: bottom;
`

export const Subtitle = styled.div`
  color: ${GRAY_DARK};
  font-size: 12px;
  line-height: 19px;

  @media (min-width: 320px) and (max-width: 480px) {
    font-size: 12px;
  }
`

export const DealerDiv = styled.div`
  margin-bottom: -12px;
  display: flex;
  font-family: Avenir;
  font-size: 11px;
  margin-top: 6px;
`

export const MarginLabel = styled.div`
  margin-left: 6px;
  background: #ffe7cb;
  padding: 0 4px;
  border-radius: 3px;
`

export const PricesRow = styled.div`
  display: flex;
  margin-top: 20px;
  margin-bottom: 6px;
  flex-wrap: wrap;
  @media (min-width: 320px) and (max-width: 480px) {
    justify-content: space-between;
  }
`

export const AvailablePrices = styled.div`
  margin-right: 20px;
  margin-bottom: 8px;
  @media (min-width: 320px) and (max-width: 480px) {
    margin: 0;
  }

  @media (min-width: 481px) and (max-width: 768px) {
    margin-right: 20px;
  }
`

export const DetailsDiv = styled.div`
  margin-top: 14px;
`

export const DetailsTitle = styled.div`
  font-weight: bold;
  font-size: 12px;
  font-family: Avenir;
  margin-bottom: 6px;
`

export const DetailsList = styled.ul`
  padding: 10px 0px 0px 20px;
  font-size: 13px;
`

export const DetailsListItem = styled.li`
  margin-bottom: 15px;
`

export const BannerMaterial = styled.img`
  max-width: 70px;
  object-fit: cover;
  max-height: 70px;
  border-radius: 3px;
  @media (max-width: 698px) {
    max-width: 82px;
  }
`

export const BannerMaterialSection = styled.div`
  display: inline-flex;
  flex-wrap: wrap;
  justify-content: center;
`

export const Description = styled.div`
  color: #5f6062;
  font-size: 13px;
  line-height: 23px;
  margin-top: 12px;
`

export const DescriptionRich = styled.div`
  width: 100%;
  margin-top: -10px;
  font-family: Avenir;
  line-height: 1.35;
`

export const ShowHowItFits = styled.div`
  margin: 0 auto;
  width: fit-content;
  border: 1px solid ${BLUE};
  padding: 4px 12px;
  color: ${BLUE};
  border-radius: 5px;
  box-shadow: 1px 1px 2px 0px lightgray;
  margin-bottom: 6px;
  transition: all .25s;
  &:hover {
    cursor: pointer;
    background-color: ${BLUE};
    color: ${WHITE};
  }
`

export const HowFits = styled.div``


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/DesignCenterCustomize/ProductTab/styledComponents.tsx